
import React from "react";
import { Button } from "@/components/ui/button";

const HowItWorksSection: React.FC = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('request-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="mt-16 bg-white rounded-lg shadow-lg p-8 text-center">
      <h2 className="text-2xl font-bold text-fabre-gray mb-4">Comment ça fonctionne ?</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
        <div className="p-4">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">1</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Demande de devis</h3>
          <p className="text-gray-600">Remplissez le formulaire et envoyez-nous un email détaillant vos besoins</p>
        </div>
        
        <div className="p-4">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">2</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Livraison</h3>
          <p className="text-gray-600">Nous livrons la benne à l'adresse et date convenues</p>
        </div>
        
        <div className="p-4">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">3</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Enlèvement et traitement</h3>
          <p className="text-gray-600">Nous récupérons la benne et traitons les déchets de manière responsable</p>
        </div>
      </div>
      
      <div className="mt-8 flex justify-center">
        <Button 
          onClick={scrollToForm}
          className="px-8 py-3 bg-fabre-green text-white rounded-md font-medium hover:bg-fabre-darkgreen transition-colors"
        >
          Demander un devis en ligne
        </Button>
      </div>
    </div>
  );
};

export default HowItWorksSection;
